import {useContext, useEffect, useState} from "react";
import {
    defaultLookback,
    generateDataSets, getDaysInMonth, getOptionalComparesByViews,
    graphMetrics, selectProps
} from "./PredictivaGraphHelper";
import {defaultFormatters} from "@leap4/frontend";
import {DateTime} from "luxon";
import { useQuery} from "react-query";
import {AxiosResponse} from "axios";
import {
    apiClient,
    Attributes,
    ButtonGradient,
    dataset,
    DynamicChart,
    Grid,
    SmartInput,
    SmartSelect,
    Mui
} from "@leap4/frontend";
import {UserViewsContext} from "../../../../contexts/userViewsContext";

// Feature flag to disable predictive graph rendering
// Set to true to re-enable the predictive graph
const ENABLE_PREDICTIVE_GRAPH = false;





export interface IPropsPredictiveGraphForAdServer{
    url: string;
    bodyObject?: any;
    organization: string
}

const _PredictiveGraphContainer = (props: IPropsPredictiveGraphForAdServer) => {
    const {userViews} = useContext(UserViewsContext)
    const [optionalCompares, setOptionalCompares] = useState([])
    const fetchPredictiveData = async (startDate, endDate,selectedLookback,bodyObject) => await apiClient.post(props.url, {startDate, endDate,selectedLookback, bodyObject})
    const {IMPRESSIONS} = Attributes.NUMERIC.ALL

    const [selectedMetricIdx, setSelectedMetric] = useState<number>(0);
    const [selectedLookback, setSelectedLookback] = useState<number>(defaultLookback)
    const [datasets, setDatasets] = useState([]);
    const [yAxisFormat, setYAxisFormat] = useState<defaultFormatters>(defaultFormatters.USD);
    const startDate = DateTime.now().startOf("month").minus({day: selectedLookback}).toISODate()
    const endDate = DateTime.now().toISODate()
    const {isLoading, error, refetch, data: response, isFetching} = useQuery(
        'predictive-graph-query',
        () => fetchPredictiveData(startDate, endDate, selectedLookback, props.bodyObject),
        {
            refetchOnWindowFocus: false,
        });
    const isLoadingOrFetching = isLoading || isFetching;

    // Sync state when query data changes (replaces onSuccess callback)
    useEffect(() => {
        if (response?.data) {
            handlePredictiveData(response.data);
        }
    }, [response?.data]);

    useEffect(() => {
        refetch()
    }, [props.organization])

    const handleSubmit = (ev) => {
        ev?.preventDefault();
        refetch();
    }


    const handlePredictiveData = (response) => {
        const {dataFromStartOfMonth,predictiveDataByLookback} = response
        const metricForDataset = graphMetrics[selectedMetricIdx].value
        if(metricForDataset===IMPRESSIONS){
            setYAxisFormat(defaultFormatters.NUMBER)
        }else{
            setYAxisFormat(defaultFormatters.USD)
        }

        const dataSets: dataset[] = generateDataSets(dataFromStartOfMonth, predictiveDataByLookback, metricForDataset)
        setDatasets(dataSets)
    }

    useEffect(()=>{
        const graphViews = userViews.activePreset?.graphViews;
        if (graphViews) {
            setOptionalCompares(getOptionalComparesByViews(graphViews))
        }
    }, [userViews.activePreset?.graphViews])

    useEffect(() => {
        if(response?.data) handlePredictiveData(response.data);
    }, [selectedMetricIdx]);


    if (error) return <>Got Error</>

    return (
        <DynamicChart
            tension={0.5}
            title={"Predictive Graph"}
            datasets={datasets}
            labels={getDaysInMonth()}
            axisFormat={{y: yAxisFormat, x: (val) => val}}
            style={{borderRadius: "16px", boxShadow: "none"}}

        >
            <form onSubmit={handleSubmit}>

                <Grid container gap={"10px"} sx={{ flexWrap: { xs: 'wrap', sm: 'nowrap' } }} alignItems={"flex-end"} justifyContent={"center"}>


                    <Grid item xs={5} sm="auto">
                        <SmartSelect selectProps={selectProps} title={"Metric"} items={graphMetrics}
                                     selectedItemInd={selectedMetricIdx} setSelectedState={setSelectedMetric}
                                     disabled={isLoadingOrFetching}/>
                    </Grid>

                    <Grid item xs={5} sm="auto">
                        <SmartInput inputType={"number"}
                                    onChange={({target}) => setSelectedLookback(+target.value > 360 ? 360 : +target.value)}
                                    helperText={"Lookback Window"}
                                    value={selectedLookback}
                                    muiProps={{
                                        size: "small",
                                        type: "number",
                                        fullWidth: true,
                                        disabled: isLoadingOrFetching
                                    }}
                                    inputProps={{min: 0, max: 360}}

                        />
                    </Grid>
                    <Grid item xs={12} sm="auto">
                        <ButtonGradient type={"submit"} disabled={isLoadingOrFetching} style={{ width: '100%' }}>SEARCH</ButtonGradient>
                    </Grid>

                </Grid>
            </form>


        </DynamicChart>
    )

}

export const PredictiveGraphContainer = (props:IPropsPredictiveGraphForAdServer) => {
    // Return null if predictive graph is disabled
    if (!ENABLE_PREDICTIVE_GRAPH) {
        return null;
    }
    
    return <>
            <_PredictiveGraphContainer url={props.url} bodyObject={props.bodyObject} organization={props.organization}/>
    </>

};
